/**
 * @author 3173
 * @description 岗位能力管理
 * @Date  2020/7/23
 */
import React from "react";
import { connect } from "dva";
import { WizTableForm } from '../../../common'
import { component_tool, framework_tool, utils_tool } from '../../../../tool';
import ScoreEditList from './../studentAbilityItem/inputScore/scoreEditList'

let { WizContainer, modelUtils } = framework_tool;
let { WizCard, WizForm, WizSpin } = component_tool;
let { Session } = utils_tool


class StudentAbiliytItemUpd extends WizContainer {
  componentName = 'studentAbiliytItemUpd';

  constructor(props) {
    super(props);
    this.state = {
    }
    this.initialValue = props.record;
  }


  _componentDidMount() {
    const {record} = this.props
    if (record) {
      if (record.list) {
        let list = [];
        record.list.forEach((e) => {
          if (e.id) {
            e.key = e.id;
          } else {
            e.key = e.name + new Date().getTime()
          }
          if (!e.abilityItemDetailId) {
            e.abilityItemDetailId = e.itemDetailId
          }
          list.push(e)    
        })
        this.initialValue.list = list
      }
      if(!this.initialValue.orgId){
        this.initialValue.orgId = record.orgNameId
      }
      if(!this.initialValue.positionIds){
        this.initialValue.positionIds = record.positionIdString
      }
    }
  }


  propsAndStateOnChange = {
    saveStudentAbilityItem: this._saveStudentAbilityItemOver.bind(this)
  }


  _saveStudentAbilityItemOver(nextProps, nextState) {
    let param = {};

    if (nextProps.saveStudentAbilityItem.code == 1) {
      wizNotice.success('保存成功');
      this.props.changeModal(false, true);
    } else {
      wizNotice.error('提交失败：' + nextProps.saveStudentAbilityItem.msg);
    }
    return true;
  }

  _ok = () => {
    this.ref.validateFields((err, values) => {
      this.values = values;
      if (!values.checkTime) {
        wizNotice.error("请选择评估时间");
      } else if (values['abilityItemDetails']) { 
        for (let i = 0; i < values['abilityItemDetails'].length; i++) {
          if (!values['abilityItemDetails'][i].score && values['abilityItemDetails'][i].score!==0) {
            wizNotice.error("请输入能力项分值");
            return;
          }
        }
      } 
      if (!err) {
        values.checkTime = new Date(values.checkTime).getTime();
        this._save(values);
      }
      return
    });
  }


  /**
   * 保存/更新
   * @param values
   * @private
   */
  _save(values) {
    const { history } = this.props;
    let apiPath = "studentAbilityItem/update";
    //let fitterValues = this.fitterFieldsValue(values)
    this.doAction({
      path: apiPath,
      payload: {
        key: "saveStudentAbilityItem",
        apiParams: {
          ...this.initialValue,
          ...values,
          list:values.abilityItemDetails
        }
      }
    });
  }



  _render() {
    const { studentAbilityItemLoading } = this.props;

    let columns = [
      {
        formItem: {
          type: "hidden",
          initialValue: this.initialValue.id
        },
        name: "id"
      },
      {
        title: "评估时间",
        name: "checkTime",
        formItem: {
          placeholder: '请选择评估时间',
          type: 'date',
          rules: [{
            required: true,
            message: '请选择评估时间'
          }],
          initialValue: this.initialValue.checkTime
        },
      },
      {
        title: "能力项",
        name: "abilityItemDetails",
        formItem: {
          type: 'diy',
          diy: ScoreEditList,
          initialValue: this.initialValue.list ? this.initialValue.list : [],
          rules: [{
            required: true,
            message: '请添加能力项',
          }]
        }
      },

    ]




    let formProps = {
      ref: 'form',
      columns,
      record: null,
      preview: null,
      footer: <></>,
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 17 }
      }
    }



    return (
      <WizSpin tip={'加载中'} spinning={studentAbilityItemLoading}>
        <WizForm key='abilityForm' className={'form-inline'} {...formProps} ref={r => {
          this.ref = r;
        }} />
      </WizSpin>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { studentAbilityItem } = state;
  const saveStudentAbilityItem = modelUtils.getModelEntity(studentAbilityItem, "saveStudentAbilityItem");
  const load = modelUtils.getLoadingState(state, ['studentAbilityItem']);
  return {
    saveStudentAbilityItem,
    ...load
  }
};
const options = { withRef: true };
export default connect(mapStateToProps, null, null, options)(StudentAbiliytItemUpd);
